import { FunctionComponent } from "react";
import styles from "./MultiStepProgress.module.scss";

type ownProps = {
  page: number;
  stepNames: Array<string>;
  onStepClick?: (index: number) => void;
};

const MultiStepProgress: FunctionComponent<ownProps> = (props) => {
  const { page, stepNames, onStepClick } = props;
  const widthPercent = 100 / stepNames.length - 1;
  return (
    <ul className={styles.processNav}>
      {stepNames.map((stepName, i) => {
        const isClickable = !!onStepClick && i !== page;
        return (
          <li
            key={i}
            className={
              (page >= i ? styles.active : "") +
              " " +
              (i < stepNames.length - 1 ? styles.arrow : "")
            }
            style={{
              width: widthPercent + "%",
              marginRight: 2,
              cursor: isClickable ? "pointer" : "default",
            }}
            onClick={() => isClickable && onStepClick && onStepClick(i)}
            title={isClickable ? `Go to ${stepName}` : undefined}
          >
            <span>{stepName}</span>
          </li>
        );
      })}
    </ul>
  );
};

export { MultiStepProgress, MultiStepProgress as default };
